<template>
  <div class="page">
    <!-- 顶部banner图 -->
    <div class="top-banner-box">
      <div class="top-banner-img">
        <div class="top-banner-center">
        </div>
      </div>
    </div>
    <div class="module">
      <div class="module-content" v-loading="loading">
        <div class="form-content">
          <el-row type="flex" class="form-row" align="middle">
            <div class="label">时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间：</div>
            <div :class="{'label-value': true, active: params.year == '' ? true:false}" @click="yearSelect('')">全部</div>
            <div :class="{'label-value': true, active: params.year == item.value ? true:false}"
               v-for="item in yearList" :key="item.value" @click="yearSelect(item.value)">{{ item.name }}</div>
          </el-row>
          <el-row type="flex" class="form-row" align="middle">
            <div class="label">一级类别：</div>
            <div :class="{'label-value': true, active: params.rollType == '' ? true:false}" @click="rollTypeSelect('')">全部</div>
            <div :class="{'label-value': true, active: params.rollType == item.name ? true:false}"
               v-for="item in rollTypeList"  @click="rollTypeSelect(item.name)" >{{item.name}}</div>
          </el-row>
          <el-row type="flex" class="form-row" align="middle">
            <div class="label">二级类别：</div>
            <div :class="{'label-value': true, active: params.rollTypeSecond == '' ? true:false}" @click="rollTypeSecondSelect('')">全部</div>
            <div :class="{'label-value': true, active: params.rollTypeSecond == item.code ? true:false}"
              v-for="item in classifyList" :key="item.uuid"  @click="rollTypeSecondSelect(item.code)">{{item.name}}</div>
          </el-row>
        </div>
        <el-empty :image-size="200" v-if="honorList.length==0"></el-empty>
        <div v-else class="list-content">
          <div :class="{'item':true, 'active': item.uuid==detailData.uuid}" v-for="item in honorList" :key="item.uuid" @click="openDetail(item)">
            <div class="text-box">
              <div class="bg-year">{{item.year}}</div>
              <div class="title">{{item.rollName}}</div>
            </div>
            <div class="img-box"></div>
          </div>
        </div>
        <!-- 分页 -->
        <div style="text-align: center;padding: 30px 0;">
          <el-pagination
            @current-change="getHonorList"
            :current-page="params.current"
            :page-size="params.pageSize"
            background
            layout="prev, pager, next"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="detailVisible"
      width="1210px"
      custom-class="detail-dialog"
      center>
      <el-table
        :data="dataVoList"
        style="width: 100%"
        class="detail-table">
        <el-table-column :label="detailData.rollName" align="center" class="one-head" label-class-name="title-th">
          <el-table-column
            :prop="item.code"
            :label="item.name"
            align="center"
            label-class-name="subtitle-th"
            v-for="item in titleList"
            :width="getColumnWidth(item.code)"
            :key="item.code">
          </el-table-column>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <div class="btn" @click="detailVisible = false">确定</div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { securityService, dictionaryTreeList, honorQuery, honorDetail } from "@/utils/honorApi";
export default {
  name: "",
  components: { },
  props: {},
  data() {
    return {
      yearList: [],
      rollTypeList: [{name: '国家级'}, {name: '自治区级'}],
      classifyList: [],
      params: {
        current: 1,
        pageSize: 15,
        year: '',
        rollType: '',
        rollTypeSecond: '',
      },
      loading: false,
      honorList: [],
      total: 0,
      detailVisible: false,
      dialogLoading: false,
      detailData: {
        rollName: ''
      },
      titleList: [],
      dataVoList: [],
      columnWidths: {},
      title: "",
      timer: null,
      headerBgUrl: "",
      num: 168,
    };
  },
  watch: {},
  computed: {},
  beforeRouteEnter(to, from, next) {
    // console.log("to=>", to)
    // console.log("from=>", from)
    // console.log("next=>", next)
    next(vm => {
      if (from.name == "expertDetail") {
        vm.$nextTick(() => {
          window.scrollTo({
            top: document.getElementById("field").offsetTop - 80,
            behavior: "smooth"
          });
        });
      }
    });
  },
  created() {
    this.getClassify();
    this.generateYearOptions(2019);
  },
  mounted() {
    window.addEventListener("scroll", this.menu);
    if (this.$route.query.type || this.$route.query.code) {
      let type = this.$route.query.type;
      let code = this.$route.query.code;
      if (type == "expert" || code == "2") {
        this.timer = setInterval(() => {
          // 直到顶部导航栏加载出来，再去做滑动操作，防止滑动后顶部导航栏颜色还是透明色
          let length = document.querySelectorAll(".changeColor").length;
          if (length > 0) {
            clearInterval(this.timer);
            window.scrollTo({
              top: document.getElementById("field").offsetTop - 80,
              behavior: "smooth"
            });
          }
        });
      }
    }
    if (this.$route.query.title) {
      this.title = this.$route.query.title;
      this.timer = setInterval(() => {
        // 直到顶部导航栏加载出来，再去做滑动操作，防止滑动后顶部导航栏颜色还是透明色
        let length = document.querySelectorAll(".changeColor").length;
        if (length > 0) {
          clearInterval(this.timer);
          window.scrollTo({
            top: document.getElementById("field").offsetTop - 80,
            behavior: "smooth"
          });
        }
      });
    }
  },
  methods: {
    generateYearOptions(start = 2019) {
      const end = new Date().getFullYear();
      this.yearList = Array.from({ length: end - start + 1 }, (_, i) => {
        const year = start + i;
        return { name: `${year}年`, value: String(year) };
      });
    },
    async getClassify() {
      const securityResponse = await securityService({});
      const found = securityResponse.find(item => item.code === 'honorCategory');
      const uuid = found ? found.uuid : null;
      if (!uuid) {
        return [];
      }
      this.classifyList = await dictionaryTreeList({ serviceUuid: uuid, current: 1, pageSize: 100 });
      this.getHonorList();
    },
    getHonorList() {
      this.loading = true;
      honorQuery(this.params).then(res => {
        this.honorList = res.list;
        this.total = res.total;
      }).finally(_ => {
        this.loading = false;
      });
    },
    yearSelect(value) {
      this.params.year = value;
      this.getHonorList();
    },
    rollTypeSelect(value) {
      this.params.rollType = value;
      this.getHonorList();
    },
    rollTypeSecondSelect(value) {
      this.params.rollTypeSecond = value;
      this.getHonorList();
    },
    async openDetail(item) {
      if (this.dialogLoading) {
        this.$message.info('数据加载中');
        return;
      }
      this.dialogLoading = true;
      await honorDetail(item.uuid).then(res => {
        if (res.success) {
          console.log('res item', res);
          this.detailData = res.data.head;
          this.titleList = res.data.titleList || [];
          this.dataVoList = res.data.dataVoList || [];
          this.detailVisible = true;
        } else {
          this.$message.error(res.message || '查询失败');
          
        }
      }).finally(_ => {
        this.dialogLoading = false;
      });
      // this.updateColumnWidths();
    },
    getColumnWidth(code) {
      const map = {
        XH: 60,
        nf: 80,
        pc: 90,
      };
      // 只返回固定列的宽度，其他列不设 width
      return map[code] || undefined;
    },
    updateColumnWidths() {
      this.columnWidths = this.calculateColumnWidths(this.titleList, this.dataVoList, {
        minW: 60,
        maxW: 420,
        padding: 24,
        fontSize: 14
      });
    },
    calculateColumnWidths(columns, data, options = {}) {
      const {
        minW = 60,        // 最小宽度
        maxW = 420,       // 最大宽度
        padding = 24,     // 左右内边距总和
        fontSize = 14,    // 字体大小（px）
        fontFamily = 'Helvetica, Arial, sans-serif'
      } = options;

      // 使用 canvas 精确测量文本宽度（推荐）
      const getTextWidth = (text) => {
        if (text == null) text = '';
        text = String(text);

        // 创建临时 canvas（性能可接受，因只在初始化/数据变更时调用）
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        context.font = `${fontSize}px ${fontFamily}`;
        return Math.ceil(context.measureText(text).width);
      };

      const widths = {};

      columns.forEach(col => {
        const code = col.code;
        const headerWidth = getTextWidth(col.name);

        let maxContentWidth = 0;
        data.forEach(row => {
          const value = row[code];
          const w = getTextWidth(value);
          if (w > maxContentWidth) maxContentWidth = w;
        });

        // 取 header 和内容的最大值
        let finalWidth = Math.max(headerWidth, maxContentWidth) + padding;
        // 限制范围
        finalWidth = Math.min(Math.max(finalWidth, minW), maxW);

        widths[code] = finalWidth;
      });

      return widths;
    },
  }
};
</script>
<style lang="less" scoped>
import 
.red-text {
  color: #FF0000;
}
.page {
  position: relative;
  top: -80px;
  margin-bottom: -80px;
  color: #2B2B2B;
  .top-banner-box {
    position: relative;
    .top-banner-img {
      height: 500px;
      width: 100%;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      background: url('~@/assets/image/honor_top_bg.png') no-repeat;
      background-size: cover;
      .top-banner-center {
        width: 1300px;
        height: 370px;
        position: relative;
      }
      .btn-row {
        margin-left: 80px;
        // background-color: white;
        display: flex;  
        position: absolute;
        bottom: 45px;
        transition: all 0.2s;
      }
      .btn {
        margin-right: 15px;
        width: 166px;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        font-weight: normal;
        color: #3672F6;
        border-radius: 4px;
        opacity: 1;
        background: rgba(255, 255, 255, 0.4);
        box-sizing: border-box;
        border: 1px solid #3672F6;
        cursor: pointer;
        user-select: none;
        &:first-child {
          background: linear-gradient(90deg, #2D50A1 0%, #6B8DDC 100%);
          color: #FFFFFF;
        }
      }
    }
  }

}
.form-content {
  .form-row {
    margin: 0 0 12px;
    flex-wrap: wrap;
  }
  .label {
    width: auto;
    white-space: nowrap;
    font-size: 18px;
    font-weight: 500;
    &#budgetType{
      margin: 0 0 0 20px; 
    }
  }
  .label-value {
    margin: 0 10px;
    width: auto;
    white-space: nowrap;
    font-size: 16px;
    font-weight: 350;
    cursor: pointer;
    &.active {
      color: #2D50A1;
    }
  }

}
.module {
  width: 100%;
  margin: auto;
  padding: 26px 0 34px;
  box-sizing: border-box;
  background: #f0f4fa;
  .module-title {
    font-size: 28px;
    font-weight: 600;
    text-align: center;
    margin: 20px 0;
  }
  .title {
    font-size: 24px;
    font-weight: bold;
    line-height: normal;
    letter-spacing: 0em;
    font-feature-settings: "kern" on;
  }
  .module-content {
    width: 1300px;
    padding: 25px;
    margin: 0 auto 30px;
    border-radius: 10px;
    background: #fff;
    box-sizing: border-box;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    .module-title {
      margin-top: 42px;
    }
    .more-btn {
      margin: 0 auto;
      width: 200px;
      height: 50px;
      border-radius: 4px;
      opacity: 1;
      background: #FFFFFF;
      box-sizing: border-box;
      border: 1px solid #2D50A1;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #2D50A1;
      font-size: 16px;
      font-weight: normal;
      cursor: pointer;
    }
    .list-content {
      width: 1300px;
      margin: 38px auto 0;
      display: flex;
      flex-wrap: wrap;
    }
    .item {
      margin-right: 25px;
      margin-bottom: 27px;
      padding: 12px 24px 12px;
      position: relative;
      width: 400px;
      height: 150px;
      border-radius: 8px;
      opacity: 1;
      background: #FFFFFF;
      box-sizing: border-box;
      border: 1px solid rgba(106, 106, 106, 0.2);
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
      color: #2B2B2B;
      cursor: pointer;
      &:nth-of-type(3n) { 
        margin-right: 0;
      }
      &.active, &:hover {
        background: #2D50A1;
        color: #fff;
      }
    }
    .text-box {
      width: 100%;
      display: flex;
      flex-direction: column;
      .bg-year {
        font-family: YouSheBiaoTiHei;
        font-size: 72px;
        font-weight: 800;
        line-height: 1;
        letter-spacing: -0.09em;
        font-variation-settings: "opsz" auto;
        color: rgba(43, 43, 43, 0.25);
        opacity: 0.5;
      }
       .title {
        position: relative;
        top: -24px;
        font-size: 24px;
        font-weight: bold;
        display: -webkit-box; /* 使用 WebKit 弹性盒子模型 */
        -webkit-box-orient: vertical; /* 垂直排列子元素 */
        -webkit-line-clamp: 2; /* 限制显示两行 */
        overflow: hidden; /* 隐藏超出内容 */
        text-overflow: ellipsis; /* 使用省略号 */
      }
    }
    .introduction {
      display: -webkit-box; /* 设置为WebKit内核的弹性盒子模型 */
      -webkit-box-orient: vertical; /* 垂直排列 */
      -webkit-line-clamp: 2; /* 限制显示两行 */
      overflow: hidden; /* 隐藏超出范围的内容 */
      text-overflow: ellipsis; /* 使用省略号 */
      font-size: 18px;
      font-weight: 350;
    }
    .btn-row {
      padding-top: 14px;
      border-top: 1px solid #CBCBCB;
      .btn {
        width: 100%;
        height: 48px;
        border-radius: 4px;
        background: linear-gradient(90deg, #2D50A1 0%, #6B8DDC 100%);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

.dialog-footer {
  .btn {
    margin: 0 auto;
    width: 146px;
    height: 48px;
    border-radius: 4px;
    opacity: 1;
    background: linear-gradient(90deg, #2D50A1 0%, #6B8DDC 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 18px;
    font-weight: 350;
    box-sizing: border-box;
  }
}

/deep/ .el-dialog.detail-dialog {
  .el-table.detail-table {
    max-height: 500px;
    overflow: hidden;
    thead { 
      color: #2B2B2B;
    }
    th.subtitle-th {
      background: #f3f7ff;
      font-size: 18px;
      font-weight: normal;
    }
    th.title-th {
      background: #E0EBFF;
      font-size: 18px;
      font-weight: bold;
    }
  }
  .el-table__body-wrapper.is-scrolling-none {
    max-height: 398px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 4px;  /* 设置垂直滚动条的宽度 */
      // display: none; /* 隐藏滚动条 */
    }
    &::-webkit-scrollbar-thumb {
      background-color: #d9d9d9; /* 滑块颜色 */
      border-radius: 2px; /* 滑块圆角 */
    }
  }
}

.btn {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/honor/honorList.vue